import React, { useRef, useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import axios from "axios";

import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { BarrioContext } from "../components/BarrioContext";
import { useAuth } from "../components/AuthContext";

import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';

const TipoGasto = () => {
    const toast = useRef(null);
    const HOST_API = process.env.REACT_APP_URL;
    const { barrio } = useContext(BarrioContext);
    const { administracionId } = useAuth();
    const [loadingBackdrop, setLoadingBackdrop] = useState(false);

    // â”€â”€â”€ Helpers compartidos â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const camelToHeader = (key) =>
        key.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()).trim();

    const formatValue = (value, type) => {
        if (value === null || value === undefined) return "";
        switch (type) {
            case "date":
                return new Date(value).toLocaleDateString("es-AR");
            case "currency":
                return typeof value === "number"
                    ? value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
                    : value;
            default:
                return typeof value === "object" ? JSON.stringify(value) : value;
        }
    };

    const flattenRow = (row) => {
        const flat = {};
        for (const [key, value] of Object.entries(row)) {
            if (typeof value === "object" && value !== null && !key.endsWith("_type")) {
                for (const [nestedKey, nestedValue] of Object.entries(value)) {
                    flat[nestedKey] = nestedValue;
                    flat[`${nestedKey}_type`] = row[`${key}_type`] ?? "currency";
                }
            } else {
                flat[key] = value;
            }
        }
        return flat;
    };

    // â”€â”€â”€ SecciÃ³n 1: Tipo Gasto â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const initialFormDataTipoGasto = {
        tipoGastoId: 0,
        descripcion: "",
    };

    const [formDataTipoGasto, setFormDataTipoGasto] = useState(initialFormDataTipoGasto);
    const [visibleTipoGasto, setVisibleTipoGasto] = useState(false);
    const [tiposGasto, setTiposGasto] = useState([]);

    const handleChangeTipoGasto = (campo, valor) => {
        setFormDataTipoGasto((prev) => ({ ...prev, [campo]: valor }));
    };

    const handleSubmitTipoGasto = async (e) => {
        e.preventDefault();
        const payload = {
            ...formDataTipoGasto,
            administracionId,
        };
        try {
            await axios.post(`${HOST_API}api/tiposgasto/SaveTipoGasto`, payload);
            setVisibleTipoGasto(false);
            fetchTiposGasto();
        } catch (err) {
            console.error(err);
        }
    };

    const fetchTiposGasto = useCallback(async () => {
        setLoadingBackdrop(true);
        try {
            const response = await axios.get(`${HOST_API}api/tiposgasto/GetTiposGasto?administracionId=${administracionId}`);
            console.log(response.data);
            setTiposGasto(response.data);
        } catch (err) {
            console.error(err.message || "Error al obtener tipos de gasto");
        } finally {
            setLoadingBackdrop(false);
        }
    }, [administracionId]);

    useEffect(() => {
        fetchTiposGasto();
    }, [fetchTiposGasto]);

    const tiposGastoFlat = useMemo(() => tiposGasto?.map(flattenRow) ?? [], [tiposGasto]);

    const columnsTipoGasto = useMemo(() => {
        if (!tiposGastoFlat?.length) return [];
        const firstRow = tiposGastoFlat[0];
        return Object.keys(firstRow)
            .filter((key) => !key.endsWith("_type") && key !== 'razonSocial')
            .map((field) => ({
                field,
                type: firstRow[`${field}_type`] ?? "text",
                header: camelToHeader(field),
            }));
    }, [tiposGasto]);

    // â”€â”€â”€ SecciÃ³n 2: Tipo Gasto Variable â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const initialFormDataTipoGastoVariable = {
        configuractionTipoGastoId: 0,
        afectaGastoBarrio: false,
        tipoGastoId: null,
        modoCalculoId: null,
        modoDistribucionId: null,
    };

    const [formDataTipoGastoVariable, setFormDataTipoGastoVariable] = useState(initialFormDataTipoGastoVariable);
    const [visibleTipoGastoVariable, setVisibleTipoGastoVariable] = useState(false);
    const [tiposGastoVariable, setTiposGastoVariable] = useState([]);
    const [tiposModoCalculo, setTiposModoCalculo] = useState([]);
    const [tiposModoDistribucion, setTiposModoDistribucion] = useState([]);

    const handleChangeTipoGastoVariable = (campo, valor) => {
        setFormDataTipoGastoVariable((prev) => ({ ...prev, [campo]: valor }));
    };

    const handleSubmitTipoGastoVariable = async (e) => {
        e.preventDefault();
        const payload = {
            ...formDataTipoGastoVariable,
            administracionId,
            barrioId: barrio.id,
        };
        try {
            await axios.post(`${HOST_API}api/configuracionTipoGasto/SaveConfiguracionTipoGasto`, payload);
            setVisibleTipoGastoVariable(false);
            fetchTiposGastoVariable();
        } catch (err) {
            console.error(err);
        }
    };

    const fetchTiposGastoVariable = useCallback(async () => {
        if (!barrio?.id) return;
        setLoadingBackdrop(true);
        try {
            const response = await axios.get(`${HOST_API}api/configuracionTipoGasto/GetConfiguracionTipoGasto?administracionId=${administracionId}&barrioId=${barrio.id}`);
            console.log(response.data);
            setTiposGastoVariable(response.data);
        } catch (err) {
            console.error(err.message || "Error al obtener tipos de gasto variable");
        } finally {
            setLoadingBackdrop(false);
        }
    }, [administracionId, barrio?.id]);

    useEffect(() => {
        fetchTiposGastoVariable();
    }, [fetchTiposGastoVariable]);

    useEffect(() => {
        axios.get(`${HOST_API}api/tipoModoCalculo/GetTipoModoCalculo`)
            .then((response) => setTiposModoCalculo(response.data))
            .catch((err) => console.error(err.message || "Error al obtener los modos de cálculo"));

        axios.get(`${HOST_API}api/tipoModoDistribucion/GetTipoModoDistribucion`)
            .then((response) => setTiposModoDistribucion(response.data))
            .catch((err) => console.error(err.message || "Error al obtener los modos de distribución"));
    }, [HOST_API]);

    const tiposGastoVariableFlat = useMemo(() => tiposGastoVariable?.map(flattenRow) ?? [], [tiposGastoVariable]);

    const columnsTipoGastoVariable = useMemo(() => {
        if (!tiposGastoVariableFlat?.length) return [];
        const firstRow = tiposGastoVariableFlat[0];
        return Object.keys(firstRow)
            .filter((key) => !key.endsWith("_type"))
            .map((field) => ({
                field,
                type: firstRow[`${field}_type`] ?? "text",
                header: camelToHeader(field),
            }));
    }, [tiposGastoVariable]);

    // â”€â”€â”€ Edit / Delete â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleEditTipoGasto = (row) => {
        setFormDataTipoGasto({ ...initialFormDataTipoGasto, ...row });
        setVisibleTipoGasto(true);
    };

    const handleDeleteTipoGasto = (id) => {
        confirmDialog({
            message: '¿Estás seguro de eliminar este tipo de gasto?',
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.delete(`${HOST_API}api/tiposgasto/DeleteTipoGasto?tipoGastoId=${id}&administracionId=${administracionId}`);
                    fetchTiposGasto();
                } catch (err) {
                    console.error(err);
                }
            },
        });
    };

    const handleEditTipoGastoVariable = async (row) => {
        setLoadingBackdrop(true);
        try {
            const response = await axios.get(`${HOST_API}api/configuracionTipoGasto/GetConfiguracionTipoGastoById`, {
                params: { configuracionTipoGastoId: row.configuractionTipoGastoId, administracionId, barrioId: barrio.id },
            });
            setFormDataTipoGastoVariable({ ...initialFormDataTipoGastoVariable, ...response.data });
            setVisibleTipoGastoVariable(true);
        } catch (err) {
            console.error(err);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar los datos para editar', life: 3000 });
        } finally {
            setLoadingBackdrop(false);
        }
    };

    const handleDeleteTipoGastoVariable = (id) => {
        confirmDialog({
            message: '¿Estás seguro de eliminar este tipo de gasto variable?',
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.delete(`${HOST_API}api/configuracionTipoGasto/DeleteConfiguracionTipoGasto?configuractionTipoGastoId=${id}&administracionId=${administracionId}`);
                    fetchTiposGastoVariable();
                } catch (err) {
                    console.error(err);
                }
            },
        });
    };

    // â”€â”€â”€ Render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    return (
        <>
            <h4>Tipo Gasto</h4>
            <br />

            <ConfirmDialog />
            <Toast ref={toast} />
            <Dialog
                visible={loadingBackdrop}
                modal
                closable={false}
                showHeader={false}
                className="backdrop-dialog"
            >
                <ProgressSpinner style={{ width: '60px', height: '60px' }} />
            </Dialog>

            {/* â”€â”€ SecciÃ³n 1: Tipo Gasto â”€â”€ */}

            <h5>Tipo Gasto</h5>

            <div className="flex align-items-center gap-3 mb-3">
                <Button
                    label="Nuevo Tipo Gasto"
                    icon="pi pi-plus"
                    onClick={() => { setFormDataTipoGasto(initialFormDataTipoGasto); setVisibleTipoGasto(true); }}
                />
            </div>

            <Dialog
                header="Tipo Gasto"
                visible={visibleTipoGasto}
                style={{ width: "50vw" }}
                breakpoints={{ "960px": "100vw" }}
                modal
                onHide={() => setVisibleTipoGasto(false)}
            >
                <form className="p-fluid grid" onSubmit={handleSubmitTipoGasto}>
                    <div className="col-12">
                        <div className="col-12 flex flex-wrap gap-3 mt-3">

                            <div className="w-full">
                                <label>Descripción</label>
                                <InputText
                                    type="text"
                                    value={formDataTipoGasto.descripcion || ""}
                                    onChange={(e) => handleChangeTipoGasto("descripcion", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="col-12 mt-3">
                                <Button label="Guardar" icon="pi pi-save" type="submit" />
                            </div>

                        </div>
                    </div>
                </form>
            </Dialog>

            <div className="grid mb-5">
                <div className="col-12">
                    <DataTable
                        value={tiposGastoFlat}
                        paginator
                        rows={10}
                        showGridlines
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        responsiveLayout="scroll"
                        emptyMessage="No hay tipos de gasto cargados"
                        className="p-datatable-gridlines bg-white"
                    >
                        {columnsTipoGasto.map(({ field, header, type }) => (
                            <Column
                                key={field}
                                field={field}
                                header={header}
                                sortable
                                body={(row) => formatValue(row[field], type)}
                            />
                        ))}
                        <Column
                            header="Acciones"
                            style={{ width: '8rem' }}
                            body={(row) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEditTipoGasto(row)} tooltip="Editar" />
                                    <Button icon="pi pi-trash" rounded className="btn-delete" onClick={() => handleDeleteTipoGasto(row.tipoGastoId)} tooltip="Eliminar" />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </div>

            {/* â”€â”€ SecciÃ³n 2: Tipo Gasto Variable â”€â”€ */}

            <h5>Configuración de Gasto</h5>

            <div className="flex align-items-center gap-3 mb-3">
                <Button
                    label="Nueva Configuración de Gasto"
                    icon="pi pi-plus"
                    onClick={() => { setFormDataTipoGastoVariable(initialFormDataTipoGastoVariable); setVisibleTipoGastoVariable(true); }}
                />
            </div>

            <Dialog
                header="Configuración de Gasto"
                visible={visibleTipoGastoVariable}
                style={{ width: "60vw" }}
                breakpoints={{ "960px": "100vw" }}
                modal
                onHide={() => setVisibleTipoGastoVariable(false)}
            >
                <form className="p-fluid grid" onSubmit={handleSubmitTipoGastoVariable}>
                    <div className="col-12">
                        <div className="col-12 flex flex-wrap gap-3 mt-3">

                            <div className="w-full md:w-4">
                                <label>Tipo Gasto</label>
                                <Dropdown
                                    value={formDataTipoGastoVariable.tipoGastoId}
                                    options={tiposGasto}
                                    optionLabel="descripcion"
                                    optionValue="tipoGastoId"
                                    onChange={(e) => handleChangeTipoGastoVariable("tipoGastoId", e.value)}
                                    className="p-inputtext-sm w-full"
                                    placeholder="Seleccionar..."
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Modo Cálculo</label>
                                <Dropdown
                                    value={formDataTipoGastoVariable.modoCalculoId}
                                    options={tiposModoCalculo}
                                    optionLabel="codigo"
                                    optionValue="modoCalculoId"
                                    onChange={(e) => handleChangeTipoGastoVariable("modoCalculoId", e.value)}
                                    className="p-inputtext-sm w-full"
                                    placeholder="Seleccionar..."
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Modo Distribución</label>
                                <Dropdown
                                    value={formDataTipoGastoVariable.modoDistribucionId}
                                    options={tiposModoDistribucion}
                                    optionLabel="codigo"
                                    optionValue="modoDistribucionId"
                                    onChange={(e) => handleChangeTipoGastoVariable("modoDistribucionId", e.value)}
                                    className="p-inputtext-sm w-full"
                                    placeholder="Seleccionar..."
                                />
                            </div>

                            <div className="w-full md:w-4 flex align-items-center gap-2 mt-2">
                                <Checkbox
                                    inputId="afectaGastoBarrio"
                                    checked={formDataTipoGastoVariable.afectaGastoBarrio}
                                    onChange={(e) => handleChangeTipoGastoVariable("afectaGastoBarrio", e.checked)}
                                />
                                <label htmlFor="afectaGastoBarrio">Afecta Gasto Barrio</label>
                            </div>

                            <div className="col-12 mt-3">
                                <Button label="Guardar" icon="pi pi-save" type="submit" />
                            </div>

                        </div>
                    </div>
                </form>
            </Dialog>

            <div className="grid">
                <div className="col-12">
                    <DataTable
                        value={tiposGastoVariableFlat}
                        paginator
                        rows={10}
                        showGridlines
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        responsiveLayout="scroll"
                        emptyMessage="No hay tipos de gasto variable cargados"
                        className="p-datatable-gridlines bg-white"
                    >
                        {columnsTipoGastoVariable.map(({ field, header, type }) => (
                            <Column
                                key={field}
                                field={field}
                                header={header}
                                sortable
                                body={(row) => formatValue(row[field], type)}
                            />
                        ))}
                        <Column
                            header="Acciones"
                            style={{ width: '8rem' }}
                            body={(row) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEditTipoGastoVariable(row)} tooltip="Editar" />
                                    <Button icon="pi pi-trash" rounded className="btn-delete" onClick={() => handleDeleteTipoGastoVariable(row.configuractionTipoGastoId)} tooltip="Eliminar" />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </div>
        </>
    );
};

export default TipoGasto;
